"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GoogleTagManagerScript = _interopRequireDefault(require("./GoogleTagManagerScript"));

var _PardotTrackingScript = _interopRequireDefault(require("./PardotTrackingScript"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _mobxReact = require("mobx-react");

var _map = _interopRequireDefault(require("lodash/map"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Layout = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Layout, _React$Component);

  var _super = _createSuper(Layout);

  function Layout() {
    _classCallCheck(this, Layout);

    return _super.apply(this, arguments);
  }

  _createClass(Layout, [{
    key: "render",
    value: function render() {
      var view = _react.default.Children.only(this.props.children);

      var dangerousViewInnerHtml = _server.default.renderToString(view);

      var pageData = (0, _extend.default)({}, this.props.data, {
        content: this.props.content,
        asyncContentViewModel: this.props.asyncContentViewModel,
        environment: this.props.environment
      });
      var startupScript = {
        __html: "typeof window.__launcher === \"function\" && window.__launcher('" + this.props.mountId + "', JSON.parse(unescape('" + escape(JSON.stringify(this.props.mobx ? pageData : view.props)) + "')), " + Boolean(this.props.editable) + ");"
      };
      var typekitLoadScript = {
        __html: "try{Typekit.load({ async: true });}catch(e){}"
      };
      var sentryInstallationScript = {
        __html: "typeof(Raven) !== \"undefined\" && Raven.config(\"" + this.props.sentryUrl + "\", " + "{release: \"" + this.props.sentryRelease + "\", whitelistUrls: [/https?:\\/\\/((.*)\\.)?gradifi(\\.firstrepublic)?\\.(com|dev|local)/]}).install()"
      };
      var content = this.props.content || {};
      var session = this.props.data ? this.props.data.session : undefined;
      var description = content.metaDescription || content.common && content.common.metaDescription;
      var keywords = content.metaKeywords || content.common && content.common.metaKeywords;
      var ogDescription = content.metaOpenGraphDescription || description;
      return /*#__PURE__*/_react.default.createElement("html", {
        lang: "en-US"
      }, /*#__PURE__*/_react.default.createElement("head", null, this.props.enableGoogleAnalyticsTracking && /*#__PURE__*/_react.default.createElement(_GoogleTagManagerScript.default, {
        trackingCode: this.props.googleTagManagerTrackingCode,
        session: session
      }), /*#__PURE__*/_react.default.createElement("title", null, this.props.title), /*#__PURE__*/_react.default.createElement("meta", {
        name: "description",
        content: description
      }), /*#__PURE__*/_react.default.createElement("meta", {
        name: "keywords",
        content: keywords
      }), /*#__PURE__*/_react.default.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      }), /*#__PURE__*/_react.default.createElement("meta", {
        charSet: "utf-8"
      }), /*#__PURE__*/_react.default.createElement("meta", {
        property: "og:title",
        content: this.props.title
      }), /*#__PURE__*/_react.default.createElement("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/_react.default.createElement("meta", {
        property: "og:description",
        content: ogDescription
      }), this.props.logo && /*#__PURE__*/_react.default.createElement("meta", {
        property: "og:image",
        content: this.props.logo
      }), this.props.meta && (0, _map.default)(this.props.meta, function (metaElement) {
        return /*#__PURE__*/_react.default.createElement("meta", _extends({
          key: metaElement.name || metaElement.property
        }, metaElement));
      }), this.props.linkElements && (0, _map.default)(this.props.linkElements, function (linkElement) {
        return /*#__PURE__*/_react.default.createElement("link", linkElement);
      }), this.props.stylesheets && (0, _map.default)(this.props.stylesheets, function (stylesheet) {
        return /*#__PURE__*/_react.default.createElement("link", {
          key: stylesheet,
          rel: "stylesheet",
          type: "text/css",
          href: stylesheet
        });
      }), /*#__PURE__*/_react.default.createElement("script", {
        src: "https://cdn.ravenjs.com/3.22.1/raven.min.js",
        crossOrigin: "anonymous"
      }), /*#__PURE__*/_react.default.createElement("script", {
        type: "text/javascript",
        src: "https://cdn.vestwell.com/web-components/help-center/index.js"
      }), /*#__PURE__*/_react.default.createElement("script", {
        type: "text/javascript",
        dangerouslySetInnerHTML: sentryInstallationScript
      }), this.props.layoutOptions && this.props.layoutOptions.loadFrbTypekitFonts && /*#__PURE__*/_react.default.createElement("script", {
        src: "https://use.typekit.net/zth6dzb.js"
      }), this.props.layoutOptions && this.props.layoutOptions.loadFrbTypekitFonts && /*#__PURE__*/_react.default.createElement("script", {
        type: "text/javascript",
        dangerouslySetInnerHTML: typekitLoadScript
      })), /*#__PURE__*/_react.default.createElement("body", {
        className: "gradifi"
      }, this.props.enableGoogleAnalyticsTracking && /*#__PURE__*/_react.default.createElement("noscript", null, /*#__PURE__*/_react.default.createElement("iframe", {
        src: "https://www.googletagmanager.com/ns.html?id=".concat(this.props.googleTagManagerTrackingCode),
        height: "0",
        width: "0",
        style: {
          display: "none",
          visibility: "hidden"
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.mountId,
        dangerouslySetInnerHTML: {
          __html: dangerousViewInnerHtml
        }
      }), this.props.scripts && this.props.scripts.map(function (script) {
        return /*#__PURE__*/_react.default.createElement("script", {
          key: script,
          src: script,
          crossOrigin: "true"
        });
      }), this.props.enablePardotTracking && /*#__PURE__*/_react.default.createElement(_PardotTrackingScript.default, null), startupScript && /*#__PURE__*/_react.default.createElement("script", {
        type: "text/javascript",
        dangerouslySetInnerHTML: startupScript
      })));
    }
  }]);

  return Layout;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  title: _propTypes.default.string,
  meta: _propTypes.default.arrayOf(_propTypes.default.object),
  stylesheets: _propTypes.default.arrayOf(_propTypes.default.string),
  scripts: _propTypes.default.arrayOf(_propTypes.default.string),
  mountId: _propTypes.default.string.isRequired,
  editable: _propTypes.default.bool,
  googleTagManagerTrackingCode: _propTypes.default.string,
  sentryUrl: _propTypes.default.string,
  sentryRelease: _propTypes.default.string,
  mobx: _propTypes.default.bool,
  enableGoogleAnalyticsTracking: _propTypes.default.bool.isRequired,
  enablePardotTracking: _propTypes.default.bool.isRequired,
  layoutOptions: _propTypes.default.shape({
    loadFrbTypekitFonts: _propTypes.default.bool
  })
}), _defineProperty(_class2, "defaultProps", {
  mountId: "view-wrapper",
  mobx: false
}), _class2)) || _class;

var _default = Layout;
exports.default = _default;